<template>
  <v-dialog v-model="showDialog" :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '510px'" persistent
    overlay-opacity="1" overlay-color="#8A8A8A">

    <v-card style="border-radius: 14px;">
      <div class="pa-8 d-flex flex-column align-center text-center" style="gap: 1.25rem;">
        <v-img :src="icon" height="100" width="100" contain />

        <div>
          <div class="plusIndigoDarken2--text text-h5">
            {{ $t("message.onboard_setup_complete_title") }}
          </div>
          <div class="primary--text mt-4 text-body-1">
            {{ $t("message.onboard_setup_complete_body") }}
          </div>
        </div>

        <plus-button class="mt-8" intent="primary" x-large @click="handleGoToDashboard">{{
          $t("message.onboard_setup_complete_cta")
        }}</plus-button>

      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import PlusButton from '../plus/PlusButton.vue';

// @ts-nocheck
export default {
  name: "SetupCompleteDialog",
  components: {
    PlusButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: require("@/assets/icons/admin+/complete_setup.svg"),
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      /**
       * @param {boolean} value
       */
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    handleGoToDashboard() {
      this.$emit("go");
    },
  },
};
</script>
